import { useEffect, useRef } from "react";

const AUTO_LOGOUT_MINUTES = 30; // Note: 30 minutes

export const useAutoLogout = (logoutCallback) => {
  console.log("useAutoLogout called");

  const timer = useRef(null);

  const resetTimer = () => {
    if (timer.current) clearTimeout(timer.current);

    timer.current = setTimeout(
      () => {
        console.log("Auto logout triggered");
        logoutCallback();
      },
      AUTO_LOGOUT_MINUTES * 60 * 1000,
    );
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "scroll", "click"];

    const handleActivity = () => resetTimer();

    // Listen to user activity
    events.forEach((event) => window.addEventListener(event, handleActivity));

    // Set initial timer
    resetTimer();

    return () => {
      if (timer.current) clearTimeout(timer.current);
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity),
      );
    };
  }, []);
};
